import React from 'react';
import { Icon } from 'elements';

const Document = ({size, className}) => (
  <Icon size={size} className={className}>
    <g>
      <path d="M10.842,0.5c-2.129,0-3.862,1.751-3.904,3.919h1.835c0.042-1.133,0.953-2.042,2.069-2.042
        c0.741,0,1.425,0.404,1.796,1.061s0.37,1.466,0,2.122s-1.055,1.061-1.796,1.061H0.009L-0.25,8.5h11.092
        c2.155,0,3.908-1.794,3.908-4S12.997,0.5,10.842,0.5"/>
      <path d="M19.565,5.5c-2.28,0-4.136,1.752-4.181,3.92h1.964c0.044-1.133,1.02-2.042,2.216-2.042
        c1.226,0,2.221,0.95,2.221,2.122s-0.994,2.122-2.221,2.122H2.027L1.75,13.5h17.815c2.308,0,4.185-1.794,4.185-4
        S21.872,5.5,19.565,5.5"/>
      <path d="M17.75,23.5c-2.179,0-3.953-1.752-3.997-3.92h1.878c0.043,1.133,0.975,2.042,2.118,2.042
        c1.172,0,2.123-0.95,2.123-2.122s-0.95-2.122-2.123-2.122H0.75L0.995,15.5h16.754c2.206,0,4.001,1.794,4.001,4
        S19.955,23.5,17.75,23.5"/>
    </g>
  </Icon>
);

export default Document;



// WEBPACK FOOTER //
// ./src/core/icons/components/Wind.jsx